var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCloseNocolor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "vuesax/outline/message-notif",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.333,
    height: 21.333
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 18053",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 1",
    d: "M13.539 6.162a1.154 1.154 0 011.744 1.5l-.112.129-7.375 7.379a1.154 1.154 0 01-1.744-1.5l.112-.129z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 2",
    d: "M6.16 6.159a1.155 1.155 0 011.5-.112l.129.112 7.385 7.383a1.154 1.154 0 01-1.5 1.744l-.129-.112L6.16 7.791a1.154 1.154 0 010-1.632z"
  }))));
}
export default SvgVuesaxOutlineCloseNocolor;